import useMediaQuery from '@eversports/klimt-design-components/use-media-query'
import useTheme from '@eversports/klimt-design-components/use-theme'
import Divider from '@eversports/klimt-primitives/legacy/Divider'
import Stack from '@eversports/klimt-primitives/legacy/Stack'

import { VenueOfferingType } from '../../../App.types'
import SectionWrapper from '../components/SectionWrapper'
import { Venue } from '../VenueProfile.types'

import BottomFixedSection from './BottomFixedSection'
import CallToActionButton from './CallToAction/CallToActionButton'
import CallToActionPrices from './CallToAction/CallToActionPrices'
import ContactIcons from './ContactInformation/ContactIcons'
import CorporateDisclaimer from './ContactInformation/CorporateDisclaimer'
import { SubscribeToNewsletter } from './ContactInformation/SubscribeToNewsletter'

interface Props {
  venue: Venue
}

const MobileSidebar = ({ venue }: Props) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const hasPublicMatches = venue.offerings.some(
    (offering) => offering === VenueOfferingType.VENUE_OFFERING_PUBLIC_MATCHES,
  )

  if (!isMobile) return null

  return (
    <>
      <SectionWrapper sx={{ py: 5, px: 4, display: { xs: 'flex', lg: 'none' } }}>
        <Stack gap={4}>
          {!hasPublicMatches && (
            <CallToActionPrices
              cheapestPrice={venue.cheapestPrice}
              cheapestTrialProductPrice={venue.cheapestTrialProductPrice}
              slug={venue.slug}
            />
          )}
          <ContactIcons contact={venue.contact} />
          <Divider sx={{ borderColor: 'lightgray' }} />
          <SubscribeToNewsletter venueId={venue.id} venueName={venue.name} />
          <CorporateDisclaimer />
        </Stack>
      </SectionWrapper>
      <BottomFixedSection>
        <CallToActionButton offerings={venue.offerings} slug={venue.slug} />
      </BottomFixedSection>
    </>
  )
}

export default MobileSidebar
